import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lettre',
  templateUrl: './lettre.component.html',
  styleUrls: ['./lettre.component.css']
})
export class LettreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
